import { Box, Stack, Typography } from '@mui/material';
import { Diagnostic } from 'vscode-languageserver-protocol';
import type { Range } from 'vscode-languageserver-types';
import { useHover } from '../../InformationPanel/HoverHook';
import ProblemIcon from './ProblemIcon';

const ProblemItem = (props: { index: number; diagnostic: Diagnostic; onSelectRange: (range: Range) => void }) => {
  const [hoverRef, isHovered] = useHover();

  // Needs work here
  function setIsHovered(arg0: boolean): void {
    console.log('Hovered: ' + arg0);
  }

  return (
    <Box
      ref={hoverRef}
      sx={{
        ...styles.diagnosticContainer,
        backgroundColor: props.index % 2 === 0 ? 'spheroGrey.diagnostic' : 'background.paper',
        ...(isHovered && styles.problemContainerHover),
      }}
      onClick={() => props.onSelectRange(props.diagnostic.range)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <ProblemIcon severity={props.diagnostic.severity} />
        <Typography>{`Line ${props.diagnostic.range.end.line + 1}:`}</Typography>
        <Typography>{props.diagnostic.message}</Typography>
        {props.diagnostic.code ? <Typography sx={styles.diagnosticSourceText}>{`  (${props.diagnostic.code})`}</Typography> : undefined}
      </Stack>
    </Box>
  );
};

const styles = {
  problemText: {
    padding: '2',
    color: 'white',
  },
  diagnosticContainer: {
    width: '100%',
    alignItems: 'left',
    justifyContent: 'left',
  },
  problemContainerHover: {
    width: '100%',
    alignItems: 'left',
    justifyContent: 'left',
    backgroundColor: 'spheroGrey.main',
  },
  diagnosticSourceText: {
    color: 'spheroGrey.main',
  },
};

export default ProblemItem;
